module.exports = window.L = require('leaflet/dist/leaflet-src');



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/src/leaflet.js
 ** module id = 935
 ** module chunks = 0 1 3 4 5 6
 **/